import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarComponent } from "../avatar/avatar.component";
import { MatCheckboxChange, MatCheckboxModule } from "@angular/material/checkbox";
import { IFriend } from "../../friends/model/friends.model";

@Component({
  selector: 'app-share-friend-card',
  imports: [AvatarComponent, MatCheckboxModule],
  templateUrl: './share-friend-card.component.html',
  styleUrls: ['./share-friend-card.component.scss'],
})
export class ShareFriendCardComponent {
  @Input() friend!: IFriend;
  @Input() checked: boolean = false;
  @Output() selectChanged = new EventEmitter();

  toggleSelection(event: MatCheckboxChange, id: number): void {
    this.selectChanged.emit({
      select: event.checked,
      id
    });
  }
}
